<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th style="width: 50px; text-align: center">Order</th>
          <th style="width: 50px; text-align: center"></th>
          <th v-for="col in columns" :key="col.key">
            {{ col.label }}
          </th>
          <th>Show Last Tested Results</th>
        </tr>
      </thead>

      <draggable v-model="localData" :handle="'.drag-handle'" @end="emitReorder(localData)" tag="tbody">
        <tr v-for="(row, index) in localData" :key="row[idKey] || index"
          :class="['table-row', isSelected(row) ? 'selected-row' : '']">
          <td class="center-cell">
            {{ index + 1 }}
          </td>

          <td class="center-cell">
            <div class="row-controls">
              <span class="drag-handle">☰</span>

              <input v-if="showCheckbox" type="checkbox" :value="row" v-model="localSelected" class="green-checkbox" />
            </div>
          </td>

          <td v-for="col in columns" :key="col.key">
            <slot :name="'col-' + col.key" :row="row">
              {{ getColumnValue(row, col.key) }}
            </slot>
          </td>
          <td>
            <vs-button @click="onClickShowLastTestedBatches(row)" size="small" color="primary" type="border"
              icon-pack="feather" icon="icon-eye"></vs-button>
          </td>
        </tr>
      </draggable>
      <show-last-tested-batch-result-pop-up ref="showLastTestedBatchResultPopUp" />
    </table>

  </div>
</template>

<script>
import draggable from "vuedraggable";
import ShowLastTestedBatchResultPopUp from "@/components/popups/TastePanel/ShowLastTestedBatchResultPopUp.vue";

export default {
  name: "DraggableTable",
  components: { draggable, ShowLastTestedBatchResultPopUp },

  props: {
    value: Array,
    rows: Array,
    columns: Array,
    type: String,
    showCheckbox: { type: Boolean, default: true },
    idKey: { type: String, default: "id" },
  },

  mounted() {
    this.localData = [...this.rows];
    this.localSelected = [...this.value];
  },

  data() {
    return {
      localSelected: [],
      localData: [],
    };
  },

  watch: {
    value(val) {
      this.localSelected = [...val];
    },
    localSelected(val) {
      this.$emit("input", val);
    },
    rows(val) {
      this.localData = [...val];
    },
  },

  methods: {
    getColumnValue(row, key) {
      return key.split('.').reduce((value, part) => {
        return value != null ? value[part] : null
      }, row)
    },
    emitReorder() {
      this.$emit("reordered", this.localData);
    },
    onSelectBatch(item) {
      this.$emit("onSelectBatch", item);
    },
    isSelected(row) {
      return this.localSelected.includes(row);
    },
    onClickShowLastTestedBatches(row) {
      this.$emit("onClickShowLastTestedBatches", row, this.type);
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px 12px;
  border: none !important;
}

.table-row:hover {
  background-color: #39b24b4d;
}

.selected-row {
  background-color: #39b24b4d !important;
}

.row-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.drag-handle {
  cursor: grab;
  font-size: 16px;
}

.center-cell {
  text-align: center;
}

.green-checkbox {
  accent-color: #39b24b;
}
</style>
